import Vue from 'vue';
import subscriberTransformer from './../../transformers/subscriber';

const success = (data, resolve) => {
  resolve(data);
};

const failed = (errors, reject) => {
  reject(subscriberTransformer.fetchCreate(errors));
};

export default (subscriberListId, subscriber) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`subscriberList/${subscriberListId}/newSubscriber`, subscriber)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriber/store.js